<template>
  <div id="form" class="modal with-header white" ref="modal" :class="routeTest === 'noAuth' ? 'row': ''"
  style="--data-themecolor:white"
  >
    <div class="header-wrapper">
      <div class="modal-header">
        <div class="title">
        <img data-v-1457af7a="" src="/img/court-logo.46478995.png" alt="Eastern Caribbean Supreme Court" width="36px" style="margin-top:12px; margin-right: 12px;" class="left">  End of Appointment Assessment Form
        </div>
        <ul class="right">
          <li>
            <a class="">
              <i class="material-icons grey-text text-darken-3">minimize</i>
            </a>
          </li>
          <li>
            <a @click="$_toggleFullScreen()">
              <i v-if="!fullScreen" class="material-icons grey-text text-darken-3">
                fullscreen
              </i>
              <i v-else class="material-icons grey-text text-darken-3">
                fullscreen_exit
              </i>              
            </a>
          </li>
          <li>
            <a class="goBack" @click="$_goBack()">
              <i class="material-icons grey-text text-darken-3">close</i>
            </a>
          </li>
        </ul>
      </div>
    </div>
  <transition name="fade-in">
    <div class="scales-dialog" v-if="viewCriteria">
     <div class="card" v-if="viewCriteria === 'lists'">
       <div class="card-content small-padding">
          <div class="card-title">
            Criteria
          </div>
          [1] Not demonstrated <br>
          [2] Insufficiently demonstrated<br>
          [3] Demonstrated <br>
          [4] Well demonstrated<br>
          [5] Very well demonstrated<br>
          <div class="card-title">
          Overall Mark
          </div>
          [1] Not suited for appointment<br>
          [2] Not yet suited for appointment<br>
          [3] Suited for appointment<br>
          [4] Well suited for appointment 
       </div>
       <div class="card-action right-align">
         <button class="btn-flat" @click="viewCriteria = false">Close</button>
       </div>
     </div>
     <div class="card subumit-action"  v-if="viewCriteria === 'submit'">
       <div class="card-content">
          <div class="card-title">
            Submit Form
          </div>
          <div class="message">
            Please note on final submission you will not longer have the ability to edit. 
          </div>
       </div>
       <div class="card-action right-align">
         <button class="btn-flat" @click="viewCriteria = false">Close</button>
         <button class="btn-flat waves-effect transparent" @click="$_saveCheck('submitted')">
           Complete 
         </button>
       </div>
     </div>
   </div>
  </transition>

    <transition name="fade-in">
   <div class="modal-content grey lighten-4" v-if="ready">
     <div class="introContent col s12">
       <collapsible
       classes="small-body-padding"
        v-if="currentStep > 0"
        :show-state="true"
        :is-active="true"
       >
       <template #header>
           <i class="material-icons left">help_outline</i>Instructions to Assessor(s) 
         </template>
        <template #body>
          <ol class="browser-default">
            <li> <a @click="currentStep = 17">You may make additional comments on step 17. Click to view </a></li>
            <li>
              <a @click="viewCriteria = 'lists'">Please have regard to the marking scales. Click to view</a>
            </li>
          </ol>
       </template>
       </collapsible>
     </div>
    <div class="form-fields">
      <div class="step" v-if="currentStep === 0">
        <div class="col s12">
           <h5>How To Complete process</h5>
           <ol class="browser-default">
             <li>
               Select a score value from 1 to 5 
             </li>
             <li>Enter comments related to the score for that particular section</li>
              <li>Use next or previos button to navigate through sections</li>
           </ol>

           <p>
             When You're Ready Select Start to begin 
           </p>
            <div class="col s12" v-if="routeTest === 'noAuth' && $route.query && $route.query.fill">
            <!--  {{$route.query && $route.query.fill ? $route.query.fill : 'No Name Gangster'}} -->
            <div class="input-field">
                <input type="text" id="fullName" name="fullName" :value="$route.query.fill">
                <label for="fullName">Evaluator</label>
            </div>
           </div>
           <div class="col s12"><button @click="currentStep += 1" class="btn waves-effect"><i class="material-icons left">assignment</i>Start</button></div>
        </div>
      </div>
    <div class="step" v-for="(field, index) in mapFields[currentStep]" :key="index *2.1758">
      <div
        v-if="field.type !== 'group'"
        :class="field.layout"
      >
        <field-types
          v-if="currentStep === field.step"
          @uploads="$_filesToUpload($event)"
          @update="$_fieldsData($event, field)"
          :data-option="field"
        >
        </field-types>
      </div>
        <div
        v-if="field.type === 'group'"
        :class="field.layout"
        >
       
        <field-types
        :class="childField.layout"
          v-for="childField in field.options" :key="childField.id"
          @uploads="$_filesToUpload($event)"
          @update="$_fieldsData($event, childField)"
          :data-option="childField"
        >
        </field-types>
      </div>
      </div>
    </div>
    <div class="review" v-if="currentStep === 17">
      <div class="col s12 m12">
        <div class="card score-card">
          <div class="card-content">
            <div class="card-title">
              Score Summary
            </div>
            <div class="math">
              {{getScore.avg}}
            </div>
          </div>
        </div>
      </div>
      <div class="col s12 m12">
        <div class="card" v-for="(f, ind) in fields" :key="ind">
          <div class="card-content">
            <div >
              <div v-if="f.type !== 'group'">
                  {{f.label}}<br>
                  {{f.values}}         
              </div>
              <div v-else>
                {{f.label}}  <i @click="currentStep = f.step" class="material-icons">edit</i><br>
                <span v-for="more in f.options" :key="more.id">
                  <span v-if="more.type === 'radio'"> Score: {{more.values}}</span>
                  <span v-if="more.type === 'text_area'"> {{more.label}}: {{more.values}}</span><br>
                </span>
                <br>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

   </div>
  </transition>
   <div class="loader-container" v-if="working">
        <div 
        class="preloader-wrapper small active">
          <div class="spinner-layer spinner-blue-only">
            <div class="circle-clipper left">
              <div class="circle"></div>
            </div><div class="gap-patch">
              <div class="circle"></div>
            </div><div class="circle-clipper right">
              <div class="circle"></div>
            </div>
          </div>
        </div>
   </div>
    <div class="custom-footer">
      <div class="col left" v-if="currentStep < fields.length + 1 && currentStep > 0">
        <button
          :disabled="currentStep === 1"
          @click="() => {currentStep -= 1}"
          class="btn  left waves-effect">
          Prev
        </button>
        <div class="col left ">
           <input class="left" ref="modalfield" style="width:56px; text-align:center; height:36px" type="number" name="pageNumber" id="pageNumber" v-model="setStep" :max="fields.length" :min="1" > 
           <div class="left" style="line-height: 38px; padding-left: 10px;">of {{fields.length}}</div>
        </div>
        <button
        v-if="currentStep !== fields.length && currentStep < fields.length  "
        :disabled="currentStep === fields.length"
          @click="() => {currentStep += 1}"
          class="btn  left waves-effect">
          Next
        </button>
        <button
          v-else
          @click="() => {currentStep += 1}"
          class="btn  left waves-effect">
          Review
        </button>
      </div>

      <div v-if="routeTest === 'Authed'">
        <button
        v-if="currentStep === 17"
        style="margin-left:6px;"
       
        @click="viewCriteria = 'submit'"
        class="btn z-depth-0 right">
        Submit
      </button>
      <button
        v-if="$route.name ==='new_eval'"
        :disabled="sending || !validateForm"
        @click="$_saveCheck('save')"
        class="btn z-depth-0 right">
        Save For Later
      </button>
      <button
        v-else
        :disabled="sending || !validateForm "
        @click="$_saveCheck('update')"
        class="btn z-depth-0 right">
        Update
      </button>
  
      </div> 
      <div v-else>
      <button
        style="margin-left:6px;"
       
        @click="viewCriteria = 'submit'"
        class="btn z-depth-0 right">
        Submit
      </button>
      </div>
      
      <button class="btn btn-flat waves-effect transparent right" @click="$_goBack()">
        Cancel
      </button>
      <div class="clear"></div>
    </div>
  </div>
</template>
<script>
import collapsible from  '@/components/collapsible.component'
import formService from '@/services/formService'
import core from '@/functions'
import fieldTypes from '@/components/records/fieldTypes.component' // records form is original template
import evalFields from '@/components/hreval/judgesEvaluation'
import {mapState} from 'vuex'
import contentService from '@/services/contentService'

const nestedObjectByString = (obj, key) => {
    key = key.replace(/\[(\w+)\]/g, '.$1');  // convert indexes to properties
    key = key.replace(/^\./, ''); // strip a leading dot
    const a = key.split('.');
    for (let i = 0, n = a.length; i < n; ++i) {
      const k = a[i];
      if (k in obj) {
        obj = obj[k];
      } else {
        return;
      }
    }
    return obj;
  }

const debounce = (func, delay) => {
  let inDebounce
  return function() {
    const context = this
    const args = arguments
    clearTimeout(inDebounce)
    inDebounce = setTimeout(() =>
      func.apply(context, args)
    , delay)
  }
}
export default {
  name:'formView',
  components:{
    fieldTypes,
    collapsible
  },
  data () {
    let vm = this
    return {
     // fields:evalFields.fields,
      working: false,
      curr_index:0,
      viewCriteria: false,
      currentStep:0,
      notify:false,
      post: new Object,
      activeFields: [],
      sending:false,
      fullScreen:false,
      ready:false,
      uploads:{
        data:new Array,
        ready:false,
        added:new Array, 
      },
      modal:{
        options:{
          onOpenStart:()=>{
              vm.ready = true 
          },
          onOpenEnd:()=>{
            core.updateFields()
          },
          dismissible:false
        },
        instance:null,
      }
    }
  },
  watch:{
    $route:function(nV){
      nV 
      ? this.modal.instance.close()
      : false
    },
    currentStep: function() {
      setTimeout(() => {
        core.updateFields()  
      });
    },
  },
  mounted(){   
    this.$_vModal()
 
    if (this.$route.name !== 'view_eval') {
    this.activeFields = evalFields.generate()
    this.fields.forEach(option => {
      if(option.type !== 'date' && option.type !== 'group') {
          option.values = ''
      } 
      else if (option.type === 'group') {
        option.options.forEach(subOption => subOption.values = '')
      }
    })
    } else if(this.$route.name === 'view_eval') {
      this.currentStep = 1
      this.$_getSingleRecord()
    }

  },
  beforeDestroy(){
    try{
      this.modal.instance.close()
      this.modal.instance !== null 
      ? this.modal.instance.destroy()
      : false
    }catch(e){
      //console.log(e)
    }
  },
  computed:{
    ...mapState({
      users:state=> state.record.users,
      records:state => state.record.records,
      user: state => state.user,
			authUser: state => state.authUser,
    }),
    routeTest:{
      get () {
        return this.$route.name === 'sol' ? 'noAuth' : 'Authed'
      }
    },
    getScore:{
      get () {
        let scoredItems = this.fields.filter(item => item.type === 'group')
        let all = scoredItems
              .map(item => item.options .find(e => e.type === 'radio'))
              .map(e => e.values)
        let total = all.map(a => a > 0 && a !== '' ? a : 0).reduce((a,b)=> a + b)
        let scoreCount = all.filter(one => !isNaN(parseInt(one)))
        return  {
          all: all,
          total,
          avg: (total / scoreCount.length).toFixed(2)
        }
      }
    },
    setStep: {
      get () {
        return this.currentStep
      },
      set:debounce(function(evt) {
       if( parseInt(evt) < (this.fields.length + 1 ) && parseInt(evt) > 0) {
            this.currentStep = parseInt(evt)
         }
         else {
           
           core.toastMessage(`Select questions between 1 and ${this.fields.length}`)
           this.$refs.modalfield.value = this.currentStep
         }
          
      },300)
    },
    fields: {
      get () {
        return this.activeFields
      },
      set () {
        
      }
    },
    mapFields: { 
      get () {
        const createGroup = (obj, key) => {
        return Object.values(obj).reduce((result, currentValue) => {
            // get the nested propert value
            const objKey = nestedObjectByString(currentValue, key)
            result[objKey] = (result[objKey] || []).concat(
              currentValue)
            return result;
          }, {});
        }
        return createGroup(this.fields,'step')
      }
    },
    validateForm:{
      get(){
        return true //this.post.to !== '' & this.post.to !== undefined ? true: false 
      }
    }
  },
  methods: {
    $_getSingleRecord() {
      contentService.getForm({id:this.$route.params.id})
      .then(res => {
        this.activeFields = JSON.parse(res.data.acf.form_string)
        this.post = res.data
        setTimeout(() => {
          core.updateFields()
        }, 400);
      })
    },
    $_vModal(){
      this.modal.instance = core.initModal(this.$refs.modal, this.modal.options)
      setTimeout(() => {
        this.modal.instance.open()
      }, 300);
    },
  
    $_fieldsData($event, field) {
      field.values = $event.data
    },
    $_toggleFullScreen(){ 
        this.$refs.modal.classList.toggle('fullScreen')  
        let test = () => {
           return  this.$refs.modal.classList.contains('fullScreen')
        } 
       if(test()) {
          this.fullScreen = true
       }
      if(!test()) {
        this.fullScreen = false        
      }
    },
    $_goBack(){
      this.$router.go(-1)
    },
    $_sendNotificaiton(t){
      let payload = {
        email: this.authUser.user_email,
        appname: this.user.name,
        status: t === 'new' ? 'New' : 'Completed',
        application: 'End of Appointment Assessment Form',
      }
      formService.notify(payload, 1223)
      // eslint-disable-next-line no-unused-vars
      .then(res =>{ 
      })
    },
    
    $_saveCheck(type){
      this.working = true
     if(type === 'save') {
        let structure = {
        title: `End of Appointment Assessment For ${this.fields.find(i => i.name === 'judicial_officer').values}`,
        status: 'publish',
         tags:[43],
          fields: {
            status: 'Saved',
            form_string: JSON.stringify(this.fields)
          }
        }
        contentService.saveForms(structure)
        .then(res => {
          if (res) this.$_sendNotificaiton('new')
          this.working = false
          core.toastMessage(`Successfully Saved`)
          this.$emit('fetch', true)
          this.$router.push({name:'evaluations'})
        })
        .catch(err => {
          return err
        })
     } else if (type === 'update') {
        let structure = {
          fields: {
            status: 'Saved',
            form_string: JSON.stringify(this.fields)
          }
        }
        contentService.updateForms(structure, this.$route.params.id)
        .then(res => {
          if(res)core.toastMessage(`Updated Assessment Form`)
          this.working = false
        })
        .catch(err => {
          return err
        })
     } else if (type === 'submitted') {
        let structure = {
          title: `End of Appointment Assessment For ${this.fields.find(i => i.name === 'judicial_officer').values}`,
          status: 'publish',
          tags:[43],
          fields: {
            status: 'Submitted',
            form_string: JSON.stringify(this.fields)
          }
        }
        contentService.updateForms(structure, this.$route.params.id)
        .then(res => {
          if (res) this.$_sendNotificaiton('final')
          this.working = false
        })
        .catch(err => {
          return err
        })
     }
    }
  }
}
</script>
<style lang="scss" scoped>
#form{
  &.modal {
     min-height: 85% !important;
    &.fullScreen {
      top: 0 !important;
      width: 100% !important;
      min-height: 100% !important;
    }
  }
  @media screen and (max-width: 680px){
    width:100%;
    top:0% !important;
    height: 100%;
    min-height: 100%;
  }
  &.modal.with-header {
    padding: 0;
    border-radius:6px;
    height: 70%;
  .header-wrapper {
    height:56px;
    position: relative;
    .modal-header {
      position: absolute;
      width:100%;
      padding:20px;
      top: 0;
      line-height:56px;
      height:100%;
      padding:0px 20px;
      border-bottom: .4px solid rgba(0,0,0,0.4);
      .title {
        font-size: 20px;
        display: inline;
      }
      ul {
        display: inline-flex;
        margin:0px;
         li {

           a {
             cursor: pointer;
             margin:0 8px;
              i {
                line-height: 56px;
              }
           }
         }
      }
    }
  }
  .modal-content {
    position: absolute;
    height: calc(100% - 122px);
    max-height: 100%;
    width: 100%;
    top:56px;
    padding:20px;
    overflow-y: auto;
  }
 }
  .custom-footer {
    position: fixed;
    bottom: 0;
    left:0;
    padding: 15px;
    width: 100%;
    background: white;
  }

.loader-container {
  top:50%;
  left:50%;
  width:64px;
  height: 64px;
  position: absolute;
  transform: translate(-50%, -50%);
  z-index: 9;
}

.scales-dialog {
    background: rgba(0, 0, 0, 0.35);
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 9;
    .card {
      border-radius: 6px;
      overflow: hidden;
      max-width: 300px;
      margin: auto;
      top: 50%;
      transform: translateY(-50%);
      .card-content {
        padding: 16px;        
      }
      .card-title {
          font-size: 18px; font-weight: 500;
          margin:0px;
      }
      .card-action {
        padding:10px 16px;
      }
    }
 ol {
   &.browser-default {
     li  {
       a {
         cursor: pointer
       }
     }
   }
 }
}
}
</style>
<style lang="scss">

#form {
    .input-field>label {
    //  top: 0;
      left: 10px;
      width: auto;
      
      color:black;
      &.active {
        
        margin-top: 5px;
        width: auto;
        }
      }
    input[type=text]:not(.dropdown-trigger), 
    input[type=text]:not(.browser-default), 
    input[type=number]:not(.browser-default),
    input[type=email]:not(.browser-default),
    input[type=select]:not(.browser-default){
      border: 1px solid rgba(158, 158, 158, 0.35);
      width: calc(100% - 16px);
      margin: 0 0 8px 0;
      padding: 0 8px;
      border-radius:4px;
      background:white;
    }
    textarea.materialize-textarea{
      box-shadow:none !important;
      border-radius:4px;
      border: 1px solid rgba(158, 158, 158, 0.35);
      margin: 0 0 8px 0;
      padding: 16px;
      min-height: 80px;
      background:white;
    }
    .radio-label {
      font-size:18px;
    }
}
</style>
<style lang="scss">
 @media print {
   nav {
     display: none;
   }
   footer {
     display: none;
   }
    .modal {
      position: relative;
      left: 0;
      top: 0;
      height: auto;
      width: 100%;
      height: 100%;
    .modal-content {
      position: relative;
      height: auto;
      max-height: none !important;
      overflow: auto !important;
    }
    }
 }

</style>